var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rooms"},[_vm._m(0),_c('RoomForm',{attrs:{"saving":_vm.saving},on:{"save":_vm.save}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breadcrumbs"},[_c('h2',[_vm._v("Create a Room")])])
}]

export { render, staticRenderFns }